import { useEffect, useState } from 'react';
import axios from 'axios';
import { subscribeRealtime } from '../lib/realtime';

// Polls an unread-count endpoint (expects {unread: n}). Updates instantly via
// the realtime WebSocket when any message mutation happens; poll is fallback.
export default function useUnreadCount(url, enabled = true, intervalMs = 60000) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!enabled || !url) return undefined;
    let alive = true;
    const load = () => axios.get(url).then((r) => { if (alive) setCount(r.data?.unread || 0); }).catch(() => {});
    load();
    const t = setInterval(load, intervalMs);
    let debounceId = null;
    const unsub = subscribeRealtime((msg) => {
      if (!msg || msg.type !== 'sync' || !(msg.path || '').includes('/messages')) return;
      clearTimeout(debounceId);
      debounceId = setTimeout(load, 400);
    });
    const onVisible = () => { if (document.visibilityState === 'visible') load(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      alive = false; clearInterval(t); clearTimeout(debounceId); unsub();
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [url, enabled, intervalMs]);
  return count;
}
